// Product gallery thumbnails: show one photo at a time and let small thumbnails switch between them.
const gallery = document.querySelector('[data-product-gallery]');
const thumbs = Array.from(document.querySelectorAll('[data-gallery-thumb]'));

if (gallery && thumbs.length) {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const setActive = (index) => {
    thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', i === index ? 'true' : 'false'));
  };

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const index = Number(thumb.dataset.galleryThumb);
      gallery.scrollTo({ left: index * gallery.clientWidth, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      setActive(index);
    });
  });

  let timer;
  gallery.addEventListener(
    'scroll',
    () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        const width = gallery.clientWidth || 1;
        setActive(Math.round(Math.abs(gallery.scrollLeft) / width));
      }, 80);
    },
    { passive: true }
  );
}
